//@ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { UserDetails } from "../../../auth/authTypes";
import { useAppDispatch } from "../../../../app/hooks";
import { fetchTeamsMemberList } from "../../../teamsMembers/teamsMemberSlice";
import { useParams } from "react-router-dom";
import { TeamsMembersResponse } from "../../../teamsMembers/teamsMemberTypes";
import DropDown from "../../../../components/common/DropDown";
import Badge from "../../../../components/common/Badge";
import {
  baseTeamMemberInviteData,
  fetchTeamsById,
} from "../../../teams/teamsSlice";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { toast } from "sonner";
import {
  baseMemberDetailsData,
  baseMemberInviteData,
} from "../../../base/baseSlice";
import { CrossIcon, ExclamationIcon } from "../../../../components/icons/Icons";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";

type ChannelProps = {
  userDetails: UserDetails | null;
};

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const TeamMemberDataDetails: React.FC<ChannelProps> = React.memo(({}) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const { userId } = useParams<{ userId: any }>();
  const [selectSearchRole, setSelectSearchRole] = useState("all");
  const roleSearchList = [
    { name: "all" },
    { name: "admin" },
    { name: "manager" },
    { name: "member" },
    { name: "pending" },
  ];
  const roleList = [{ name: "admin" }, { name: "manager" }, { name: "member" }];
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [addToBase, setAddToBase] = useState(false);
  const [selectRole, setSelectRole] = useState<any>("admin");
  const [addBaseLoading, setAddBaseLoading] = useState(false);
  const [teamId, setTeamId] = useState<number | null>(null);
  const [memberRoles, setMemberRoles] = useState<Map<number, any>>(new Map());
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [searchName, setSearchName] = useState("");
  // fetch team by id

  const [selectedRole, setSelectedRole] = useState(roleList[0]);

  // Initialize member roles when boards are fetched
  useEffect(() => {
    if (boardsFetched.length > 0) {
      const initialRoles = new Map();
      boardsFetched.forEach((item) => {
        // Set initial role based on existing data or default to "admin"
        initialRoles.set(
          item.user_id,
          roleList.find((r) => r.name === item.role) || roleList[0],
        );
      });
      setMemberRoles(initialRoles);
    }
  }, [boardsFetched]);

  const handleRoleChange = (userId: number, newRole: any) => {
    setMemberRoles((prev) => {
      const updated = new Map(prev);
      updated.set(userId, newRole);
      return updated;
    });

    // Here you would typically call an API to update the role in the backend
    // console.log(`Role updated for user ${userId} to ${newRole.name}`);
    // Add your role change handling logic here
  };

  // In Teams component
  useEffect(() => {
    const fetchTeams = async () => {
      setDataLoading(true);
      try {
        const baseResponse = await dispatch(
          fetchTeamsMemberList({ teamId: userId, role: selectSearchRole }),
        );

        if (fetchTeamsMemberList.fulfilled.match(baseResponse)) {
          setBoardsFetched(baseResponse.payload.data);
        } else {
          setBoardsFetched([]);
          console.error("Failed to fetch teams:", baseResponse.payload);
        }
      } catch (error) {
        console.error("Error fetching teams:", error);
        setBoardsFetched([]);
      } finally {
        setDataLoading(false);
      }
    };
    if (userId) {
      fetchTeams();
    }
  }, [userId, selectSearchRole, dispatch]);

  const handleSearchRoleChange = useCallback((role: string) => {
    setSelectSearchRole(role);
  }, []);

  // add team member
  const handleAddMember = () => {
    setAddToBase(true);
    setTeamId(userId);
  };

  const add_baseHandler = () => {
    setAddBaseLoading(true);
    if (email.length === 0) {
      setEmailError("Enter your email address");
      setAddBaseLoading(false);
    } else {
      dispatch(
        baseTeamMemberInviteData({
          payload: { email, role: selectRole, team_id: userId },
          userId: baseId,
        }),
      )
        .unwrap()
        .then((res: any) => {
          toast.success(res?.message);
          setAddToBase(false);
        })
        .catch((err: any) => {
          setAddBaseLoading(false);
        })
        .finally(() => {
          setAddBaseLoading(false); // End loading
        });
    }
  };

  useEffect(() => {
    const invitedByMembers = boardsFetched.map((boardItem: any) => {
      const member = baseMembers.find(
        (member: any) =>
          member.user_id === boardItem.user_id ||
          member.user_id === boardItem.user_id,
      );
      return member;
    });
    const validMembers = invitedByMembers.filter(
      (member: any) => member !== undefined,
    );
    localStorage.setItem(
      "baseMemberChannelInviteList",
      JSON.stringify(validMembers),
    );

    return () => {
      // Cleanup code (if needed)
    };
  }, [boardsFetched, baseMembers]); // Dependencies: re-run the effect if boardsFetched or baseMembers change

  const [baseMemberDetails, setBaseMemberDetails] = useState<any>(null);

  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        try {
          const baseResponse = await dispatch(baseMemberDetailsData(baseId));
          setBaseMemberDetails(baseResponse.payload);
        } catch (error) {
          console.error("Error fetching base member details:", error);
        }
      };
      fetchData();
    }
  }, [baseId, dispatch]);

  const handleSearchNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchName(e.target.value);
  };

  return (
    <>
      <div className="flex flex-col gap-y-1 mt-12 mb-[22px]">
        <h2 className="text-[15px] font-medium leading-[22.8px] text-[#1c2024]">
          Team Members
        </h2>
        <p className="text-[13.3px] leading-[19px] text-[#5c5c5e] font-medium">
          View and manage the list of members in your team, their roles, and
          permissions.
        </p>
      </div>

      <div className=" w-full justify-center">
        {/* <div className='bg-[#e0e0e0] w-full h-[1px] my-6'></div> */}
        <div className=" lg:mb-6 flex items-center w-full gap-x-3 mb-[16px]">
          <div className="w-full lg:w-[40%]">
            <label
              htmlFor="searchEmail"
              className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5"
            >
              Base Members
            </label>
            <div className="mt-[6px]">
              <input
                id="searchEmail"
                name="searchEmail"
                type="text"
                placeholder="Search by name"
                className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                value={searchName}
                onChange={handleSearchNameChange}
              />
            </div>
          </div>

          <div className="w-full lg:w-[20%]">
            <div className="mt-[32px]">
              <DropDown
                onChangeValue={handleSearchRoleChange}
                data={roleSearchList}
                previousValue={selectSearchRole}
              />
            </div>
          </div>
          <div className="w-full lg:w-[40%]">
            <div className="mt-[32px] flex justify-end">
              <button
                onClick={() => handleAddMember()}
                className="flex w-fit justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white
                    shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Add team Member
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-solid border-[#0009321f]">
          <div className=" w-full flex items-center">
            <div className="font-semibold text-[#1c2024] text-sm w-[80%] px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]">
              Name
            </div>
            <div className="font-semibold text-[#1c2024] w-[20%] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]">
              Role
            </div>
          </div>
          {dataLoading ? (
            <div className="flex items-center justify-center relative z-50 h-full py-10">
              <div className="simple-spinner-loader">
                <span></span>
              </div>
            </div>
          ) : boardsFetched.length === 0 ? (
            <div className="w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3">
              <ExclamationIcon />
              <p className="text-[#0000007a] text-[13px]">No results found</p>
            </div>
          ) : (
            <div className="w-full">
              {boardsFetched.length > 0 && (
                <ul role="list" className="list-none w-full">
                  {boardsFetched.map((items: any, index: number) => {
                    const currentRole =
                      memberRoles.get(items.user_id) || roleList[0];
                    const invitedByMember = baseMembers.find(
                      (member: any) => member.id === items.user_id,
                    );
                    const data = invitedByMember?.name?.charAt(0).toUpperCase();
                    return (
                      <li
                        key={index}
                        className="flex flex-row items-center justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full  border-b border-[#0009321f] last-of-type:border-none"
                      >
                        <div className="flex min-w-0 gap-x-3 items-center">
                          {items?.profile_pic ? (
                            <img
                              src={
                                items?.profile_pic &&
                                `${process.env.REACT_APP_API_BASE_URL}/${items?.profile_pic}`
                              }
                              alt="Selected file preview"
                              className="h-[30px] w-[30px] flex-none rounded-full text-gray-300"
                            />
                          ) : (
                            <div className="flex shrink-0">
                              <span
                                className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-none text-[13px] font-semibold text-white capitalize"
                                style={{
                                  backgroundColor: "rgb(107, 114, 128)",
                                }}
                              >
                                {items.name.charAt(0).toUpperCase()}
                              </span>
                            </div>
                          )}
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-4 text-gray-900 capitalize">
                              <span className="inset-x-0 -top-px bottom-0" />
                              <span className="text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b]">
                                {items?.name}
                              </span>

                              <Badge status={items?.status} />
                            </p>
                            <p className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">
                              {items?.email}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex flex-1 justify-end">
                            <Listbox
                              value={currentRole}
                              onChange={(newRole) =>
                                handleRoleChange(items.user_id, newRole)
                              }
                            >
                              <div className="relative ">
                                <ListboxButton
                                  className="relative w-[108px] rounded-md bg-white py-1.5 px-[10px] text-left text-gray-900
                                                          focus:outline-none text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer"
                                >
                                  <div className="flex items-center gap-1.5 justify-between">
                                    {currentRole.name && (
                                      <span className="block truncate capitalize">
                                        {currentRole.name}
                                      </span>
                                    )}

                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.5}
                                      stroke="currentColor"
                                      className="size-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m19.5 8.25-7.5 7.5-7.5-7.5"
                                      />
                                    </svg>
                                  </div>
                                </ListboxButton>
                                <ListboxOptions
                                  className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                 bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                  data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                                >
                                  {roleList.map((role) => (
                                    <ListboxOption
                                      key={role.name}
                                      value={role}
                                      className={({ active }) =>
                                        classNames(
                                          active
                                            ? "bg-gray-200 text-[#1d2025]"
                                            : "text-gray-900",
                                          "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                        )
                                      }
                                    >
                                      <span className="block truncate font-normal capitalize">
                                        {role.name}
                                      </span>
                                    </ListboxOption>
                                  ))}
                                </ListboxOptions>
                              </div>
                            </Listbox>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>

      <Dialog open={addToBase} onClose={setAddToBase} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setAddToBase(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Add Member
                </DialogTitle>

                <div className="w-full mt-5">
                  <label
                    htmlFor="email"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Email
                  </label>
                  <div className="mt-[6px]">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmailError("");
                        setEmail(e.target.value);
                      }}
                      autoComplete="email"
                      placeholder="Email address"
                      className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                    border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                    />
                    <p
                      className="mt-[6px] text-sm text-red-600"
                      id="email-error"
                    >
                      {emailError}
                    </p>
                  </div>
                </div>
                <div className="w-full mt-4">
                  <label
                    htmlFor="country"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                  >
                    Role
                  </label>
                  <div className="mt-[6px]">
                    <DropDown
                      onChangeValue={(e: any) => setSelectRole(e)}
                      data={roleList}
                      previousValue={selectRole}
                    />
                  </div>
                </div>
              </div>
              <div className="flex gap-x-4 items-center justify-end mt-5">
                <button
                  onClick={add_baseHandler}
                  type="submit"
                  className="flex w-fit justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {addBaseLoading ? (
                    <div className="flex items-center  gap-[6px]">
                      Add to Base
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    "Add to Base"
                  )}
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
});

export default TeamMemberDataDetails;
